require("./bootstrap");
import router from "./router.js";

//#region START VUEJS APP ------------------------------------------
import {
    createApp
} from "vue";

const app = createApp({});
app.use(router);

//#endregion START VUEJS APP ------------------------------------------

//#region  VUE EXTRA CONFIG ------------------------------------------
app.config.devtools = false;
app.config.debug = false;
app.config.silent = true;
//#endregion VUE EXTRA CONFIG ---------------------------------------

//#region PRIMEVUE CONFIG ------------------------------------------
import PrimeVue from "primevue/config";
import "primevue/resources/themes/saga-blue/theme.css"; //theme
import "primevue/resources/primevue.css"; //core css
import "primeicons/primeicons.css"; //icons

app.use(PrimeVue, {
    locale: {
        startsWith: "Comienza con",
        conºains: "Contiene",
        notContains: "No contiene",
        endsWith: "Termina con",
        equals: "Igual a",
        notEquals: "Diferente de",
        noFilter: "No filtrar",
        lt: "Menor que",
        lte: "Menor o igual que",
        gt: "Mayor que",
        gte: "Mayor o igual que",
        dateIs: "Fecha es",
        dateIsNot: "Fecha no es",
        dateBefore: "Fecha antes de",
        dateAfter: "Fecha despues de",
        clear: "Limpiar",
        apply: "Aplicar",
        matchAll: "Coincide con todos",
        matchAny: "Coincide con alguno",
        addRule: "Añadir regla",
        removeRule: "Eliminar regla",
        accept: "Aceptar",
        reject: "Rechazar",
        choose: "Elegir",
        upload: "Subir",
        cancel: "Cancelar",
        dayNames: [
            "Domingo",
            "Lunes",
            "Martes",
            "Miércoles",
            "Jueves",
            "Viernes",
            "Sábado",
        ],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
        ],
        monthNamesShort: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic",
        ],
        today: "Hoy",
        weekHeader: "Sm",
        firstDayOfWeek: 1,
        dateFormat: "dd/mm/yy",
        weak: "Débil",
        medium: "Medio",
        strong: "Fuerte",
        passwordPrompt: "Introduzca la contraseña",
        emptyFilterMessage: "No hay resultados",
        emptyMessage: "No hay datos disponibles",
    },
});

import Button from "primevue/button";
app.component("Button", Button);

import Tag from "primevue/tag";
app.component("Tag", Tag);

import ConfirmationService from "primevue/confirmationservice";
app.use(ConfirmationService);

import Tooltip from "primevue/tooltip";
app.directive("tooltip", Tooltip);

import ToastService from "primevue/toastservice";
app.use(ToastService);

import Toast from "primevue/toast";
app.component("Toast", Toast);

import Message from "primevue/message";
app.component("Message", Message);

import InputText from "primevue/inputtext";
app.component("InputText", InputText);

import InputNumber from "primevue/inputnumber";
app.component("InputNumber", InputNumber);

import Calendar from "primevue/calendar";
app.component("Calendar", Calendar);

import DataTable from "primevue/datatable";
app.component("DataTable", DataTable);

import Column from "primevue/column";
app.component("Column", Column);

import ColumnGroup from "primevue/columngroup"; //optional for column grouping
app.component("ColumnGroup", ColumnGroup);

import Row from "primevue/row";
app.component("Row", Row);

import Dropdown from "primevue/dropdown";
app.component("Dropdown", Dropdown);

import ConfirmDialog from "primevue/confirmdialog";
app.component("ConfirmDialog", ConfirmDialog);

import Dialog from "primevue/dialog";
app.component("Dialog", Dialog);

//#endregion PRIMEVUE CONFIG---------------------------------------

//#region VUE COMPONENTS START --------------------------------------

//------COMPONENTES DE MODULOS----------

//#endregion VUE COMPONENTS START -----------------------------------

//#region COMPONENTES DE MODULOS---------------------------------------
//#endregion COMPONENTES DE MODULOS -----------------------------------

//#region EVENTBUS CONFIG ------------------------------------------
import mitt from "mitt";
const emitter = mitt();
app.config.globalProperties.emitter = emitter;
//#endregion EVENTBUS CONFIG ---------------------------------------

//#region MOMENTJS CONFIG ------------------------------------------
import moment from "moment";
app.config.globalProperties.moment = moment;

app.config.globalProperties.$filters = {
    date(value, format) {
        return value ? moment(value).format(format) : "";
    },
};
//#endregion MOMENTJS CONFIG ---------------------------------------

//#region PERMISSIONS FUNCTIONS ------------------------------------------
app.config.globalProperties.$hasPermission = (permissionName) => {
    return Laravel.permissions.indexOf(permissionName) !== -1;
};
app.config.globalProperties.$hasRole = (roleName) => {
    return Laravel.roles.indexOf(roleName) !== -1;
};
//#endregion PERMISSIONS FUNCTIONS ---------------------------------------

app.mount("#app");
